import React, { FC } from 'react'
import CheckboxListFacet from '../components/CheckboxListFacet'
import { BaseFacetProps } from '../types'

const OVERRIDE_ORIENTATION_RULES = {
  landscape: 'Horizontal',
  portrait: 'Vertical',
  square: 'Square',
}

const ORIENTATION = ['landscape', 'portrait', 'square']

const StatusFacet: FC<BaseFacetProps> = ({ baseUrl, nextAppRoute }) => {
  return (
    <CheckboxListFacet
      facetName='orientation'
      attributesList={ORIENTATION}
      overrideCheckboxTextRules={OVERRIDE_ORIENTATION_RULES}
      baseUrl={baseUrl}
      nextAppRoute={nextAppRoute}
    />
  )
}

export default StatusFacet
